import { AlertTriangle } from 'lucide-react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shared/ui/primitives'

const LABEL = 'Invoice still live in Stripe'
const TOOLTIP =
  'An invoice was voided in BlindBook but is still live in Stripe, so the customer can still pay it. Open the booking to retry the void.'

export function ProviderVoidFailureBadge() {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex shrink-0 items-center text-destructive"
            aria-label={LABEL}
          >
            <AlertTriangle className="size-4" />
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-64">{TOOLTIP}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
